/*
 * @Author: Dom
 * @Date: 2022-05-21 16:04:35
 * @LastEditTime: 2022-05-21 17:52:01
 * @LastEditors: Dom
 * @FilePath: \seller-web\src\services\code.ts
 */
import request from '@/utils/request'
import qs from 'qs'
import {VerificParams} from './data.d'


export async function getImageCode(): Promise<any>{
    return request({
        url: '/seller/v1/login/getDynamicImage',
        method: 'POST'
    })
}

export async function getVerificCode(params:VerificParams): Promise<any>{
    return request({
        url: '/seller/v1/login/sendVerificationCode',
        method: 'POST',
        data: qs.stringify(params)
    })
}
